/** Namespace `dependencies` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const dependencies = {
  title: "Phụ thuộc",
  loadFailed: "Không đọc được đồ thị phụ thuộc.",
  introMiddle: " nghĩa là ",
  introStrong: "A cần B",
  introAfter: " để chạy. Xếp theo « bao nhiêu thứ cần nó » — hỏng một đỉnh ở đầu bảng thì hỏng nhiều thứ.",
  cycles: "{count} chu trình trong phụ thuộc lúc chạy — không có thứ tự khởi động nào đúng.",
  cyclesNote:
    "Chu trình chạy được trong đời thường vì mọi bên đều đã sẵn sàng — nó chỉ lộ ra khi cả cụm được triển khai lại cùng lúc.",
  emptyTitle: "Danh mục chưa khai phụ thuộc nào.",
  emptyBefore: "Phụ thuộc khai trong manifest ở mã nguồn, nạp bằng ",
  emptyMiddle: ". Trống ở đây nghĩa là ",
  emptyStrong: "chưa khai",
  emptyAfter: ", không phải « các dịch vụ độc lập với nhau ».",
  "col.service": "Dịch vụ",
  "col.tier": "Mức",
  "col.dependents": "Bao nhiêu thứ cần nó",
  "col.needs": "Nó cần",
  "col.neededBy": "Bị ai cần",
} as const;
